module.exports = __webpack_public_path__ + "Bottom Background.c94b29d4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/landing/Bottom Background.png
// module id = SUvr
// module chunks = 0